module.exports = __webpack_public_path__ + "static/media/ccna1.a71bc798.png";